import { Model } from '@datamodel';

export class Event extends Model {
    static get uuid() { return 'eventId' };
    static get model() {
        return ({
            name: '',
            colorPalette: {},
            photo: '',
        })
    }

    static get keymap() {
        return {
            id: Event.uuid,
        }
    }
}
